import { render, staticRenderFns } from "./CollectionIndex.vue?vue&type=template&id=30115f4e&lang=pug&"
import script from "./CollectionIndex.vue?vue&type=script&lang=js&"
export * from "./CollectionIndex.vue?vue&type=script&lang=js&"
import style0 from "./CollectionIndex.vue?vue&type=style&index=0&id=30115f4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports